import React from "react";

const CheckCircle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM8.71004 11.1547L10.47 12.9247L15.07 8.32471L16.48 9.74471L10.47 15.7547L7.29004 12.5747L8.71004 11.1547Z"
        fill="#0ABA0A"
      />
    </svg>
  );
};

export default CheckCircle;
